export const LOGO = "https://icon-library.com/images/food-app-icon/food-app-icon-0.jpg";
export const SEARCH_LOGO = "https://tse2.mm.bing.net/th?id=OIP.47jxyhFA1ibPiI_wg7KaDQHaHL&pid=Api&P=0&h=220";
export const LOGIN = "https://tse4.mm.bing.net/th?id=OIP.jAioCeiE6Cwhq9Ph3dee4gHaHa&pid=Api&P=0&h=220";
export const STAR = "https://tse2.mm.bing.net/th?id=OIP.Vq4iQC8p3quhWYipAjoIIAAAAA&pid=Api&P=0&w=300&h=300";
export const LINKEDIN = "https://www.linkedin.com/in/alankrita-mohapatra/";
export const FOOD = "https://www.annmariegianni.com/wp-content/uploads/2014/05/brain-foods-1.jpg";
export const CONTACT = "https://img.freepik.com/premium-vector/young-man-using-laptop-computer-desk-working-online-illustration_24877-69116.jpg?w=2000";
export const EMPTY = "https://tse2.mm.bing.net/th?id=OIP.VEtjKjhwDm_M6AXOQmbZbwHaEX&pid=Api&P=0&h=220"; 
export const BACKEND_URL = "https://foodieco-backend-216f2650ef56.herokuapp.com";
export const RESTAURANT_LIST = `${BACKEND_URL}/api/restaurants`;
export const MENU_URL = `${BACKEND_URL}/api/menu`;
export const CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

